import { Button, Form, Input } from 'antd';
import React, { useEffect } from 'react';
import { useLangsState } from './State';
import { useForm } from 'antd/es/form/Form';

function Edit() {
    let { editNashr, ed } = useLangsState()
    let [form] = useForm()
    useEffect(() => {
        form.setFieldsValue(ed)
    }, [ed])
    return (
        <Form
            form={form}
            labelCol={{
                span: 24,
            }}
            wrapperCol={{
                span: 24,
            }}
            onFinish={editNashr}
            autoComplete="off"
        >
            <Form.Item hidden name={'id'}>
                <Input />
            </Form.Item>
            <Form.Item label="Til nomi" name={'til'}>
                <Input />
            </Form.Item>
            <Form.Item>
                <Button htmlType="submit" type="primary">Saqlash</Button>
            </Form.Item>
        </Form>
    );
}

export default Edit;